import { gql } from '@apollo/client';

export const REQUEST_DATANORM_REBUILD = gql`
    mutation RequestDatanormRebuild {
        requestDatanormRebuild {
            success
            alreadyRequestedToday
            message
        }
    }
`;
